import { render, staticRenderFns } from "./PreviewPublish.ts.vue?vue&type=template&id=f3d3edd2"
import script from "./PreviewPublish.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewPublish.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreviewPublish.ts.vue?vue&type=style&index=0&id=f3d3edd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports